import Usuario from "./Usuario";
import TipoPessoaVeiculo from "./TipoPessoaVeiculo";
import Municipio from "./Municipio";
import TipoDocumentoPessoa from "./TipoDocumentoPessoa";
import Notificacao from "./Notificacao";
import Pais from "./Pais";

class PessoaAutoInfracaoTransito {
    constructor(
        {
            id = null,
            auto_infracao_transito_id = null,
            tipo_pessoa_veiculo_id = null,
            data_pessoa_vinculacao = null,
            tipo_documento_pessoa_id = null,
            numero_documento = null,
            numero_registro_cnh = null,
            uf_expedicao_cnh = null,
            cpf_condutor = null,
            nome = null,
            logradouro = null,
            numero = null,
            complemento = null,
            bairro = null,
            cep = null,
            uf = null,
            municipio_id = null,
            created_at = null,
            updated_at = null,
            deleted_at = null,
            usuario_id = null,
            ind_titular_infracao = null,
            tipo_modelo_cnh_id = null,
            ind_assinatura_infrator = null,
            ind_nit_notificacao_autuacao = null,
            ind_nap_notificacao_penalidade = null,
            ind_multa_nic = null,
            ind_adesao_veiculo_sne = null,
            data_adesao_veiculo_sne = null,
            ind_adesao_orgao_autuador_sne = null,
            ind_condutor_identificado_agente = null,
            sne_indicador_adesao_veiculo = null,
            pais_cnh_id = null,

            //ORM
            usuario = {},
            tipo_pessoa_veiculo = {},
            municipio = {},
            tipo_documento_pessoa = {},
            tipo_modelo_cnh = {},
            notificacao = [],
            pais_cnh = {}
        } = {}
    ) {
 
        this.id = id,
        this.auto_infracao_transito_id = auto_infracao_transito_id;
        this.tipo_pessoa_veiculo_id = tipo_pessoa_veiculo_id;
        this.data_pessoa_vinculacao = data_pessoa_vinculacao;
        this.tipo_documento_pessoa_id = tipo_documento_pessoa_id;
        this.numero_documento = numero_documento;
        this.numero_registro_cnh = numero_registro_cnh;
        this.uf_expedicao_cnh = uf_expedicao_cnh;
        this.cpf_condutor = cpf_condutor;
        this.nome = nome;
        this.logradouro = logradouro;
        this.numero = numero;
        this.complemento = complemento;
        this.bairro = bairro;
        this.cep = cep;
        this.uf = uf;
        this.municipio_id = municipio_id;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.deleted_at = deleted_at;
        this.usuario_id = usuario_id;
        this.ind_titular_infracao = ind_titular_infracao;
        this.tipo_modelo_cnh_id = tipo_modelo_cnh_id;
        this.ind_assinatura_infrator = ind_assinatura_infrator;  
        this.ind_nit_notificacao_autuacao = ind_nit_notificacao_autuacao;  
        this.ind_nap_notificacao_penalidade = ind_nap_notificacao_penalidade;  
        this.ind_adesao_veiculo_sne = ind_adesao_veiculo_sne,
        this.data_adesao_veiculo_sne = data_adesao_veiculo_sne,
        this.ind_adesao_orgao_autuador_sne = ind_adesao_orgao_autuador_sne,        
        this.ind_multa_nic = ind_multa_nic,        
        this.ind_condutor_identificado_agente = ind_condutor_identificado_agente,
        this.sne_indicador_adesao_veiculo = sne_indicador_adesao_veiculo,
        this.pais_cnh_id = pais_cnh_id
        
        
        //ORM
        this.usuario = usuario ? new Usuario(usuario) : new Usuario();
        this.tipo_pessoa_veiculo = tipo_pessoa_veiculo ? new TipoPessoaVeiculo(tipo_pessoa_veiculo) : new TipoPessoaVeiculo();
        this.municipio = municipio ? new Municipio(municipio) : new Municipio();
        this.tipo_documento_pessoa = tipo_documento_pessoa ? new TipoDocumentoPessoa(tipo_documento_pessoa) : new TipoDocumentoPessoa();
        this.tipo_modelo_cnh = tipo_modelo_cnh ? new TipoDocumentoPessoa(tipo_modelo_cnh) : new TipoDocumentoPessoa();
        this.pais_cnh = pais_cnh ? new Pais(pais_cnh): new Pais();

        this.notificacao = notificacao && Array.isArray(notificacao) && notificacao.length > 0 ? notificacao.map(nt => {return new Notificacao(nt)}) : [];
    }
}

export default PessoaAutoInfracaoTransito;